import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
import OutsideClickHandler from 'react-outside-click-handler'
import SingleDatePicker from '../../../../../../components/SingleDatePicker'

export const TextInput = ({
  error,
  errorMessage,
  label = '',
  placeholder = '',
  value = '',
  onChange = (val) => null,
  isDisabled = false,
  isReadOnly = false,
  isDate,
  color = 'accent0'
}) => {

  const [inputValue, setInputValue] = useState(value)
  const [debouncedValue, setDebouncedValue] = useState(inputValue)
  const [showCalendar, setShowCalendar] = useState(false)

  useEffect(() => {
    if (value !== inputValue) {
      setInputValue(value)
    }
  }, [value])

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      setDebouncedValue(inputValue)
    }, 300)

    return () => {
      clearTimeout(debounceTimeout)
    }
  }, [inputValue])

  useEffect(() => {
    if (value !== inputValue) {
      onChange(debouncedValue)
    }
  }, [debouncedValue])

  const handleInputChange = (event) => {
    setInputValue(event.target.value)
  }

  const toggleCalendar = (value) => {
    isDate && setShowCalendar(value)
  }

  const textInputClassName = classNames('text-field__input1', {
    'text-field__input_disabled': isDisabled,
    'text-field_readonly': isReadOnly
  })

  return (
    <OutsideClickHandler onOutsideClick={() => toggleCalendar(false)}>
      <div className='chart-editor-text-input'>
        {label &&
          <div className='chart-editor-text-input__wrapper'>
            <div className='chart-editor-text-input__ellipsis chart-editor__label'>
              <label className="text-field__label1">{label}</label>
            </div>
            <div className='custom-tooltip'>{label}</div>
          </div>
        }
        <div className={classNames('text-field__wrapper', {
          'text-field__error': error
        })}>

          <input
            type='text'
            className={textInputClassName}
            placeholder={placeholder}
            value={inputValue}
            onChange={handleInputChange}
            onFocus={() => toggleCalendar(true)}
            disabled={isDisabled}
            readOnly={isReadOnly}
          />
          {error && <div
            className={classNames("text-field__error", {
            })}
          >
            {errorMessage}
          </div>
          }
        </div>
        {isDate && showCalendar &&
          <SingleDatePicker
            toggleCalendar={setShowCalendar}
            hideOnChange
            selectedDate={new Date(inputValue)}
            onChange={setInputValue}
            color={color}
          />
        }
      </div>
    </OutsideClickHandler>
  )
}